import { observer } from 'mobx-react-lite';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import './App.css';
import samplePdf from './assets/pdf/sample.pdf';
import theme from './common/color/theme';
import ScrollToTop from './common/components/ScrollToTop';
import './common/i18n/i18n';
import { applyTranslationsFromLocalStorage } from './common/i18n/i18nHotApply';
import { SHOW_DEV_MENU } from './config';
import './css/fonts.css';
import BBMain from './views/base/BBMain';
import BusinessCleanDryRoomPage from './views/business/BusinessCleanDryRoomPage';
import BusinessCryogenicPipingPage from './views/business/BusinessCryogenicPipingPage';
import BusinessDataCenterPage from './views/business/BusinessDataCenterPage';
import BusinessMainPage from './views/business/BusinessMainPage';
import BusinessSecondaryBatteryPage from './views/business/BusinessSecondaryBatteryPage';
import BusinessTeflonCoatingPage from './views/business/BusinessTeflonCoatingPage';
import NotFoundPage from './views/common/NotFoundPage';
import PdfViewer from './views/common/PdfViewer';
import CustomerInquiryPage from './views/customer/CustomerInquiryPage';
import CustomerMainPage from './views/customer/CustomerMainPage';
import CustomerReportCenterPage from './views/customer/CustomerReportCenterPage';
import IntroduceCEOMessagePage from './views/introduce/IntroduceCEOMessagePage';
import IntroduceCIPage from './views/introduce/IntroduceCIPage';
import IntroduceHistoryPage from './views/introduce/IntroduceHistoryPage';
import IntroduceLocationPage from './views/introduce/IntroduceLocationPage';
import IntroduceMainPage from './views/introduce/IntroduceMainPage';
import IntroduceOrganizationChartPage from './views/introduce/IntroduceOrganizationChartPage';
import IntroduceQualificationPage from './views/introduce/IntroduceQualificationPage';
import IntroduceVisionPage from './views/introduce/IntroduceVisionPage';
import CompanyNewsMainPage from './views/promotion/CompanyNewsMainPage';
import PromotionMainPage from './views/promotion/PromotionMainPage';
import BBPeopleMainPage from './views/recruit/BBPeopleMainPage';
import RecruitBenefitsPage from './views/recruit/RecruitBenefitsPage';
import RecruitMainPage from './views/recruit/RecruitMainPage';
import RecruitOurPeoplePage from './views/recruit/RecruitOurPeoplePage';
import PrivacyPolicyMainPage from './views/terms/PrivacyPolicyMainPage';
import TermsMainPage from './views/terms/TermsMainPage';

export const GlobalTypography = createGlobalStyle`
  html {
    font-size: 16px; /* 기본 1rem = 16px */
  }

  @media (max-width: 1919px) {
    html {
      font-size: 12px;
    }
  }

  @media (max-width: 1199px) {
    html {
      font-size: 9px;
    }
  }

  @media (max-width: 559px) {
    html {
      font-size: 8px;
    }
  }
}
`;

const App = observer(() => {
  if (SHOW_DEV_MENU) {
    applyTranslationsFromLocalStorage();
  }


  return (
    <ThemeProvider theme={theme}>
      <GlobalTypography />
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<BBMain
            key="/"
            childrenDesktop={<IntroduceMainPage />}
            childrenTablet={<IntroduceMainPage />}
            childrenMobile={<IntroduceMainPage />}
          />} />
          <Route path="/introduce/vision" element={<BBMain
            key="/introduceVision"
            childrenDesktop={<IntroduceVisionPage />}
            childrenTablet={<IntroduceVisionPage />}
            childrenMobile={<IntroduceVisionPage />}
          />} />
          <Route path="/introduce/ceo" element={<BBMain
            key="/introduceCEO"
            childrenDesktop={<IntroduceCEOMessagePage />}
            childrenTablet={<IntroduceCEOMessagePage />}
            childrenMobile={<IntroduceCEOMessagePage />}
          />} />
          <Route path="/introduce/history" element={<BBMain
            key="/introduceHistory"
            childrenDesktop={<IntroduceHistoryPage />}
            childrenTablet={<IntroduceHistoryPage />}
            childrenMobile={<IntroduceHistoryPage />}
          />} />
          <Route path="/introduce/qualification" element={<BBMain
            key="/introduceQualification"
            childrenDesktop={<IntroduceQualificationPage />}
            childrenTablet={<IntroduceQualificationPage />}
            childrenMobile={<IntroduceQualificationPage />}
          />} />
          <Route path="/introduce/organization" element={<BBMain
            key="/introduceOrganization"
            childrenDesktop={<IntroduceOrganizationChartPage />}
            childrenTablet={<IntroduceOrganizationChartPage />}
            childrenMobile={<IntroduceOrganizationChartPage />}
          />} />
          <Route path="/introduce/ci" element={<BBMain
            key="/introduceCI"
            childrenDesktop={<IntroduceCIPage />}
            childrenTablet={<IntroduceCIPage />}
            childrenMobile={<IntroduceCIPage />}
          />} />
          <Route path="/introduce/location" element={<BBMain
            key="/introduceLocation"
            childrenDesktop={<IntroduceLocationPage />}
            childrenTablet={<IntroduceLocationPage />}
            childrenMobile={<IntroduceLocationPage />}
          />} />
          <Route path="/business" element={<BBMain
            key="business"
            childrenDesktop={<BusinessMainPage />}
            childrenTablet={<BusinessMainPage />}
            childrenMobile={<BusinessMainPage />}
          />} />
          <Route path="/business/battery" element={<BBMain
            key="businessBattery"
            childrenDesktop={<BusinessSecondaryBatteryPage />}
            childrenTablet={<BusinessSecondaryBatteryPage />}
            childrenMobile={<BusinessSecondaryBatteryPage />}
          />} />
          <Route path="/business/datacenter" element={<BBMain
            key="businessDataCenter"
            childrenDesktop={<BusinessDataCenterPage />}
            childrenTablet={<BusinessDataCenterPage />}
            childrenMobile={<BusinessDataCenterPage />}
          />} />
          <Route path="/business/dryroom" element={<BBMain
            key="businessDryRoom"
            childrenDesktop={<BusinessCleanDryRoomPage />}
            childrenTablet={<BusinessCleanDryRoomPage />}
            childrenMobile={<BusinessCleanDryRoomPage />}
          />} />
          <Route path="/business/teflon" element={<BBMain
            key="businessTeflon"
            childrenDesktop={<BusinessTeflonCoatingPage />}
            childrenTablet={<BusinessTeflonCoatingPage />}
            childrenMobile={<BusinessTeflonCoatingPage />}
          />} />
          <Route path="/business/cryogenic" element={<BBMain
            key="businessCryogenic"
            childrenDesktop={<BusinessCryogenicPipingPage />}
            childrenTablet={<BusinessCryogenicPipingPage />}
            childrenMobile={<BusinessCryogenicPipingPage />}
          />} />
          <Route path="/promotion" element={<BBMain
            key="promotion"
            childrenDesktop={<PromotionMainPage />}
            childrenTablet={<PromotionMainPage />}
            childrenMobile={<PromotionMainPage />}
          />} />
          <Route path="/promotion/news" element={<BBMain
            key="promotionNews"
            childrenDesktop={<CompanyNewsMainPage />}
            childrenTablet={<CompanyNewsMainPage />}
            childrenMobile={<CompanyNewsMainPage />}
          />} />
          <Route path="/promotion/pdf" element={<PdfViewer
            key="promotionPdf"
            fileUrl={samplePdf}
          />} />
          <Route path="/customer" element={<BBMain
            key="customer"
            childrenDesktop={<CustomerMainPage />}
            childrenTablet={<CustomerMainPage />}
            childrenMobile={<CustomerMainPage />}
          />} />
          <Route path="/customer/inquiry" element={<BBMain
            key="customerInquiry"
            childrenDesktop={<CustomerInquiryPage />}
            childrenTablet={<CustomerInquiryPage />}
            childrenMobile={<CustomerInquiryPage />}
          />} />
          <Route path="/customer/report" element={<BBMain
            key="customerReport"
            childrenDesktop={<CustomerReportCenterPage />}
            childrenTablet={<CustomerReportCenterPage />}
            childrenMobile={<CustomerReportCenterPage />}
          />} />
          <Route path="/recruit" element={<BBMain
            key="recruit"
            childrenDesktop={<RecruitMainPage />}
            childrenTablet={<RecruitMainPage />}
            childrenMobile={<RecruitMainPage />}
          />} />
          <Route path="/recruit/people" element={<BBMain
            key="recruitPeople"
            childrenDesktop={<RecruitOurPeoplePage />}
            childrenTablet={<RecruitOurPeoplePage />}
            childrenMobile={<RecruitOurPeoplePage />}
          />} />
          <Route path="/recruit/benefits" element={<BBMain
            key="recruitBenefits"
            childrenDesktop={<RecruitBenefitsPage />}
            childrenTablet={<RecruitBenefitsPage />}
            childrenMobile={<RecruitBenefitsPage />}
          />} />
          <Route path="/recruit/bbpeople" element={<BBMain
            key="recruitBBPeople"
            childrenDesktop={<BBPeopleMainPage />}
            childrenTablet={<BBPeopleMainPage />}
            childrenMobile={<BBPeopleMainPage />}
          />} />
          <Route path="/terms" element={<BBMain
            key="terms"
            childrenDesktop={<TermsMainPage />}
            childrenTablet={<TermsMainPage />}
            childrenMobile={<TermsMainPage />}
          />} />
          <Route path="/terms/policy" element={<BBMain
            key="termsPolicy"
            childrenDesktop={<PrivacyPolicyMainPage />}
            childrenTablet={<PrivacyPolicyMainPage />}
            childrenMobile={<PrivacyPolicyMainPage />}
          />} />
          <Route path="/" element={<BBMain
            key="/"
            childrenDesktop={<IntroduceMainPage />}
            childrenTablet={<IntroduceMainPage />}
            childrenMobile={<IntroduceMainPage />}
          />} />
          <Route path="*" element={<NotFoundPage />} /> {/* 잘못된 URL 처리 */}
        </Routes>
      </Router>
    </ThemeProvider>
  );
});

export default App;